import { Button } from '../seller-toolbar/toolbar_button';

export function SellerToolbar() {
	const { Handlebars } = window;

	const toolbarTemplate = Handlebars.compile(
		document.getElementById('seller-toolbar-template').innerHTML,
	);

	const dropdownButtonTemplate = Handlebars.compile(
		document.getElementById('seller-dropdown-button-template').innerHTML,
	);

	function DropdownButton(data) {
		Button.call(this);
		let instanceVars = {
			children: [],
			setTemplate: (template) => {
				if (typeof template === 'undefined') {
					template = dropdownButtonTemplate;
				}
				this.template = template;
			},
			addChild: (button) => {
				if (!(button instanceof Button)) {
					button = new Button(button);
				}
				button.setChild(true);
				this.children.push(button);
			},
			addChildren: (children) => {
				$.each(children, (index, child) => {
					this.addChild(child);
				});
			},
			setData: (data) => {
				this.data = data;
				$.each(this.children, (index, child) => {
					child.setData(data);
				});
			},
			getChildren: () => this.children,
			childrenHtml: () => $.map(this.getChildren(), (child) => child.html()).join('\n'),
			templateData: () => ({
				id: this.getDomId(),
				label: this.label,
				mobile_label: this.mobileLabel,
				icon: this.icon.html(),
				children_html: this.childrenHtml(),
				classes: this.getClasses(),
			}),
			bindListeners: () => {
				// no need to bind, already handles its action
			},
		};

		Object.assign(this, instanceVars);
		this.init(data);
		return this;
	}

	let instanceVars = {
		buttons: [],
		containerClass: 'toolbar-container',
		template: toolbarTemplate,
		registerButton: (buttonData, parentName) => {
			let parentButton = parentName ? this.findButton(parentName) : null;
			let newButton = new Button(buttonData);
			if (parentButton) {
				parentButton.addChild(newButton);
			} else {
				this.addButton(newButton);
			}
		},
		registerDropdownButton: (buttonData) => {
			let newButton = new DropdownButton(buttonData);
			this.addButton(newButton);
			let children = buttonData['children'];
			if (typeof children !== 'undefined') {
				$.each(children, (index, childData) => {
					newButton.addChild(childData);
				});
			}
		},
		getContainers: () => $('.' + this.containerClass),
		addButton: (button) => {
			this.buttons.push(button);
			this.buttons.sort((a, b) => {
				if (a.getWeight() < b.getWeight()) {
					return -1;
				}
				if (a.getWeight() > b.getWeight()) {
					return 1;
				}
				return 0;
			});
		},
		findButton: (buttonName) => {
			let foundButton = null;
			$.each(this.buttons, (index, button) => {
				if (button.getName() === buttonName) {
					foundButton = button;
				}
			});
			return foundButton;
		},
		buttonsHtml: () => {
			let buttonsHtmlArr = [];
			$.each(this.buttons, (index, button) => {
				if (button.shouldRender()) {
					buttonsHtmlArr.push(button.html());
				}
			});
			return buttonsHtmlArr.join('\n');
		},
		setData: (data) => {
			$.each(this.buttons, (index, button) => {
				button.setData(data);
			});
		},
		templateData: () => ({
			buttons_html: this.buttonsHtml(),
		}),
		html: () => this.template(this.templateData()),
		render: () => {
			$('.' + this.containerClass).html(this.html());
		},
		redraw: () => {
			this.render();
		},
	};

	Object.assign(this, instanceVars);

	return this;
}
